export default __webpack_public_path__ + "static/media/primaafp5.5e47ebee.jpg";